import {useEffect} from "react"
import {EventKey, EventPayloads, subscribe} from "../utils/eventBus"

export const useEventBus = <K extends EventKey>(
  event: K,
  handler: (data: EventPayloads[K]) => void
): void => {
  useEffect(() => {
    return subscribe(event, handler)
  }, [event, handler])
}